import { render, staticRenderFns } from "./companyWarehouseList.vue?vue&type=template&id=385c6cf8&scoped=true"
import script from "./companyWarehouseList.vue?vue&type=script&lang=js"
export * from "./companyWarehouseList.vue?vue&type=script&lang=js"
import style0 from "./companyWarehouseList.vue?vue&type=style&index=0&id=385c6cf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c6cf8",
  null
  
)

export default component.exports